import { render, staticRenderFns } from "./CustomerAdditionalInfo.vue?vue&type=template&id=1ae558c7&scoped=true&"
import script from "./CustomerAdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerAdditionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAdditionalInfo.vue?vue&type=style&index=0&id=1ae558c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae558c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
